import {
  Accordion,
  AccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Typography,
  withStyles,
} from '@material-ui/core';
import { ContentWrapperWidget, MainTemplate } from '../../components/layouts';
import React, { ChangeEvent, FC, useState } from 'react';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LegalInfo from '../../components/widgets/Organizations/LegalInfo';
import MainInfo from '../../components/widgets/Organizations/MainInfo';
import OrganizationAthlete from '../../components/widgets/Organizations/Athletes';
import OrganizationDepartmentAffiliation from '../../components/widgets/Organizations/DepartmentAffilation';
import OrganizationStructure from '../../components/widgets/Organizations/OrganizationStructure';
import OrganizationTypeSports from '../../components/widgets/Organizations/TypeSports';
import { blue } from '@material-ui/core/colors';
import moment from 'moment';
import onExpand from '../../utils/onExpand';
import { useOrganizationByIdQuery } from '../../api';
import { usePermission } from '../../hooks/usePermission';
import { useRouteMatch } from 'react-router-dom';
import userRights from '../../config/userRights';

type AccordionTypes =
  | 'MainInfo'
  | 'OrganizationStructure'
  | 'LegalInfo'
  | 'TypeSports'
  | 'ClassifierValues'
  | 'DepartmentAffiliation'
  | undefined;

const AccordionSummary = withStyles({
  root: {
    backgroundColor: blue[700],
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    color: 'white',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary) as any;

// @TODO: Update View for Dialog request to Archive

const Single: FC<{}> = () => {
  const {
    params: { id },
  } = useRouteMatch();

  const { hasAdditionalFilter } = userRights();
  const [expanded, setExpanded] = useState<AccordionTypes>('MainInfo');

  const { data } = useOrganizationByIdQuery({ variables: { id, ...hasAdditionalFilter?.organizations } });

  const access = usePermission('directory', 'organizations');

  const handleChangeAccordion = (panel: AccordionTypes) => (event: ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : undefined);
  };
  const OptionTitleArchive = data?.dirOrganization?.archive
    ? ` (В архиве с ${moment(data?.dirOrganization?.archive?.date).format('DD.MM.YYYY')})`
    : '';

  const regionId = data?.dirOrganization?.dirRegion?.value;

  return (
    <MainTemplate
      pageName=""
      title={id === 'new' ? 'Добавить новую организацию' : `Организация: ${data?.dirOrganization?.name}`}
      url=""
    >
      <ContentWrapperWidget>
        {id === 'new' ? (
          <h2>Добавить новую организацию</h2>
        ) : (
          <h2>
            Организация: {data?.dirOrganization?.name}
            {OptionTitleArchive}
          </h2>
        )}
        <Accordion expanded={expanded === 'MainInfo'} onChange={handleChangeAccordion('MainInfo')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Общая информация</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {onExpand(expanded, 'MainInfo') && <MainInfo id={id} readonly={!access.includes(2)} />}
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'OrganizationStructure'}
          onChange={handleChangeAccordion('OrganizationStructure')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Структура Организации</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {onExpand(expanded, 'OrganizationStructure') && (
              <OrganizationStructure id={id} readonly={!access.includes(2)} />
            )}
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'LegalInfo'}
          onChange={handleChangeAccordion('LegalInfo')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Юридическая информация</Typography>
          </AccordionSummary>
          <AccordionDetails style={{ flexDirection: 'column' }}>
            {onExpand(expanded, 'LegalInfo') && <LegalInfo id={id} readonly={!access.includes(2)} />}
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'TypeSports'}
          onChange={handleChangeAccordion('TypeSports')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Вид спорта</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {onExpand(expanded, 'TypeSports') && (
              <OrganizationTypeSports id={id} regionId={regionId} readonly={!access.includes(2)} />
            )}
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'DepartmentAffiliation'}
          onChange={handleChangeAccordion('DepartmentAffiliation')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Ведомственная принадлежность</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {onExpand(expanded, 'DepartmentAffiliation') && (
              <OrganizationDepartmentAffiliation id={id} readonly={!access.includes(2)} />
            )}
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'ClassifierValues'}
          onChange={handleChangeAccordion('ClassifierValues')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Спортсмены</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {onExpand(expanded, 'ClassifierValues') && (
              <OrganizationAthlete id={id} regionId={regionId} readonly={!access.includes(2)} />
            )}
          </AccordionDetails>
        </Accordion>
      </ContentWrapperWidget>
    </MainTemplate>
  );
};

export default Single;
